<template>
  <div>
    <div class="box box-primary">
        <section class="content">
          <div class="row">
            <div class="col-md-12 bg-green">
                <span class="pull-left">Branch To Branch Fund Transfer</span> <center><strong>{{ $store.state.settingRecord.companyName }}</strong></center>
            </div>
            <div class="col-md-12" style="background-color: #FFFFD9;">
              <form @submit.prevent="addFundTransfer()">
                <div class="col-md-6">
                  <div class="row">
                    <div class="form-group">
                        <div class="col-sm-4">
                        <label><strong>Payment Type </strong></label>
                        </div>
                        <div class="col-sm-6">
                        <label>
                        <input type="radio" name="group_id" class="minimal" value="4" v-on:change="changeRecordByPayment" v-model="form.group_id" required>
                        <i class="fa fa-check text-success"></i> <span class="text-success">Cash</span>
                        <has-error :form="form" field="group_id"></has-error>
                        </label>
                        <label>
                        <input type="radio" name="group_id" class="minimal" value="1" v-on:change="changeRecordByPayment" v-model="form.group_id" required>
                        <i class="fa fa-remove text-danger"></i> <span class="text-danger">Bank</span>
                        <has-error :form="form" field="group_id"></has-error>
                        </label>
                        </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                        <label>From Branch <span class="red">*</span></label>
                    </div>
                    <div class="col-sm-6">
                        <v-select :options="branches" v-model="fromBranch" v-on:input="getFromBranch(fromBranch)" label="name" name="from_branch_id" accesskey="b" style="background-color: white;" required>
                        </v-select>
                        <has-error :form="form" field="from_branch_id"></has-error>
                    </div>
                  </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <label>From Branch Ledger <span class="red">*</span></label>
                        </div>
                        <div class="col-sm-6">
                            <v-select :options="fromBranchledgers" label="name" name="from_branch_ledger_cb_id" v-on:input="getFromBranchLedger(fromBranchledger)" placeholder="Select" v-model="fromBranchledger" style="background-color: white;" accesskey="l" required></v-select>
                            <has-error :form="form" field="from_branch_ledger_cb_id"></has-error>
                        </div>
                    </div>
                    
                    <div class="row">                                    
                        <div class="col-sm-4">
                            <label>Amt <span class="red">*</span></label>
                        </div>
                        <div class="col-sm-6">
                            <input v-model="form.amount" type="number" step=".01" name="amount" class="form-control" accesskey="n" required/>
                            <has-error :form="form" field="amount"></has-error>                               
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-sm-4">
                            <label>Date <span class="red">*</span></label>
                        </div>
                        <div class="col-sm-6">
                            <input required v-model="form.date" type="date" name="date" class="form-control" :class="{ 'is-invalid': form.errors.has('date') }" accesskey="d" />
                            <has-error :form="form" field="date"></has-error>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <label>To Branch <span class="red">*</span></label>
                        </div>
                        <div class="col-sm-6">
                            <v-select required :options="branches" v-model="toBranch" v-on:input="getToBranch(toBranch)" label="name" name="from_branch_id" style="background-color: white;" accesskey="b">
                        </v-select>
                            <has-error :form="form" field="to_branch_id"></has-error>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <label>To Branch Ledger <span class="red">*</span></label>
                        </div>
                        <div class="col-sm-6">
                            <v-select required :options="toBranchledgers" label="name" v-on:input="getToBranchLedger(toBranchledger)" name="to_branch_ledger_cb_id" placeholder="Select" v-model="toBranchledger" style="background-color: white;" accesskey="l"></v-select>
                            <has-error :form="form" field="to_branch_ledger_cb_id"></has-error>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Narration</label>
                        <textarea v-model="form.narration" class="form-control"></textarea>
                      </div>
                      <button class="btn btn-success" type="submit"><i class="fa fa-save"></i> Save</button>
                      <br>
                    </div>
                </div>
              </form>
            </div>
          </div>
        </section>
    </div>
    <section class="content">
    <!-- Default box -->
    <!-- /.box -->

     <!-- Default box -->
      <div class="info-box"  v-if="canAccess('bank-view-any')">
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Amount</th>
                <th class="hidden-xs">Ledger</th>
                <th class="hidden-xs">From Branch</th>
                <th class="hidden-xs">To Branch</th>
                <th class="hidden-xs">Date</th>
                <th class="hidden-xs">Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in fundtransfers.data" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td>{{ row.amount }}</td>
                <td class="hidden-xs">{{ row.from_ledger.name }}</td>
                <td class="hidden-xs">{{ row.from_branch.name }}</td>
                <td class="hidden-xs">{{ row.to_branch.name }}</td>
                <td class="hidden-xs">{{ row.date | myDate }}</td>
                <td class="hidden-xs">
                  {{ row.status }}
                </td>
                <td>
                  <div class="btn-group dropup">
                    <button type="button" class="btn btn-flat btn-xs dropdown-toggle" data-toggle="dropdown">
                      Task <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right" role="menu">
                      <!-- <li v-if="canAccess('voucher-view')">
                        <a @click="viewPlan(row)"><i class="fa fa-eye"></i> View</a>
                      </li> -->
                      <li v-if="canAccess('voucher-delete')">
                        <a @click="deleteModal(row.id)"><i class="fa fa-trash"> </i> Delete</a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->
  </section>
  </div>
</template>
<script>
    import GetBranch from '../../mixins/BranchRecords'
    import AddLedger from './AddLedger.vue'
    export default {
      name: 'FundTransfer',
      mixins: [GetBranch],
      components: {
        'add-ledger': AddLedger
      },
      data () {
        return {
          pagination: {
            current_page: 0,
            from: 0,
            to: 0,
            total: 0,
            last_page: 0,
            per_page: 0,
            first_page_url: null,
            last_page_url: null,
            next_page_url: null,
            prev_page_url: null,
            path: null
          },
          per_page: 10,
          table_search: '',
          branches: [],
          fundtransfers: [],
          fundtransfer: {},
          fromBranch: {},
          toBranch: {},
          form: new Form({
            id: '',
            group_id: '',
            from_branch_id: null,
            to_branch_id: null,
            from_ledger_id: '',
            to_ledger_id: '',
            from_branch_ledger_cb_id: '',
            to_branch_ledger_cb_id: '',
            date: new Date().toISOString().slice(0, 10),
            narration: '',
            amount: null,
            status: ''
          }),
          fromBranchledgers: [],
          fromBranchledger: {},
          toBranchledgers: [],
          toBranchledger: {},
          total: 0
        }
      },
      methods: {
        canAccess (perm) {
          return this.$store.state.permissions.includes(perm)
        },
        changeRecordByPayment () {
          this.fromBranch = {}
          this.toBranch = {}
          this.fromBranchledgers = []
          this.fromBranchledger = {}
          this.form.from_branch_id = ''
          this.form.from_ledger_id = ''
          this.form.from_branch_ledger_cb_id = ''
          this.toBranchledgers = []
          this.toBranchledger = {}
          this.form.to_branch_id = ''
          this.form.to_branch_ledger_cb_id = ''
          this.form.to_ledger_id = ''
        },
        addFundTransfer () {
          this.form.status = 'active'
          this.$axios
            .post('btobtransfer', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
            .then(() => {
              Toast.fire({icon: 'success', title: 'Fund Transfer Successfully'})
              this.form.reset()
              // location.reload()
            //   this.$router.push({name: 'voucher'})
            })
            .catch(function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this))
        },
        deleteModal (id) {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
              this.$axios
                .delete('btobtransfer/' + id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
                .then((data) => {
                  // console.log(data)
                  Swal.fire('Deleted!', 'Your Record has been deleted.', 'success')
                  Fire.$emit('AfterCreate')
                }).catch(function (error) { console.log(error) })
            }
          })
        },
        getFromBranch (from) {
          this.fromBranchledgers = []
          this.fromBranchledger = {}
          this.form.from_branch_id = ''
          this.form.from_ledger_id = ''
          this.form.from_branch_ledger_cb_id = ''
          this.form.from_branch_id = from.id
          this.total = 0
          this.$axios
            .get('branchledger?all=all&status=active&group_id=' + this.form.group_id + '&branch_id=' + this.form.from_branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              this.fromBranchledgers = data.data
              $.each(this.fromBranchledgers, function (key, value) {
                this.fromBranchledgers[key].name = value.ledger.name
              }.bind(this))
            }).catch(function (error) { console.log(error) })
        },
        getFromBranchLedger (record) {
          this.form.from_branch_ledger_cb_id = ''
          this.form.from_branch_ledger_cb_id = record.id
          this.form.from_ledger_id = ''
          this.form.from_ledger_id = record.ledger_id
        },
        getToBranch (to) {
          this.toBranchledgers = []
          this.toBranchledger = {}
          this.form.to_branch_ledger_cb_id = ''
          this.form.to_ledger_id = ''
          this.form.to_branch_id = to.id
          this.total = 0
          this.$axios
            .get('branchledger?all=all&status=active&group_id=' + this.form.group_id + '&branch_id=' + this.form.to_branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              this.toBranchledgers = data.data
              $.each(this.toBranchledgers, function (key, value) {
                this.toBranchledgers[key].name = value.ledger.name
              }.bind(this))
            }).catch(function (error) { console.log(error) })
        },
        getToBranchLedger (record) {
          this.form.to_branch_ledger_cb_id = ''
          this.form.to_branch_ledger_cb_id = record.id
          this.form.to_ledger_id = ''
          this.form.to_ledger_id = record.ledger_id
        },
        changefilter (page = null, pg = null) {
          var pageUrl = ''
          if (this.pagination.first_page_url && pg === 'first') {
            pageUrl += this.pagination.first_page_url
          } else if (this.pagination.last_page_url && pg === 'last') {
            pageUrl += this.pagination.last_page_url
          } else if (this.pagination.next_page_url && pg === 'next') {
            pageUrl += this.pagination.next_page_url
          } else if (this.pagination.prev_page_url && pg === 'prev') {
            pageUrl += this.pagination.prev_page_url
          } else if (this.pagination.path != null) {
            pageUrl += this.pagination.path
          } else {
            pageUrl += 'btobtransfer'
          }
          if (pg == null) {
            pageUrl += `?per_page=${this.per_page}`
          } else {
            pageUrl += `&per_page=${this.per_page}`
          }
          if (page != null) {
            pageUrl += `&page=${page}`
          }
          this.$axios
            .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              this.fundtransfers = data.data
              this.pagination = data.data
            }).catch(function (error) { console.log(error) })
        }
      },
      created () {
        this.changefilter()
        this.getBranch()
        Fire.$on('AfterCreate', () => {
          this.changefilter()
        })
      }
    }
</script>
    
    <style scoped>
    .help-block {
        color:red;
    }
    </style>



// WEBPACK FOOTER //
// FundTransfer.vue?0745ff60